import { useState, useEffect } from 'react'
import { useClientProjectContext } from '../../../../../../context/ClientProjectContext'
import { ROUTED_REPORT_MODES } from '../../../../../reports/types/ReportTypes'
import { ArtifactPolymorphic } from '@/api/generated/models'

const useProjectAccess = ({
  mode,
  artifact,
  solutionId,
}: {
  mode?: string
  artifact?: ArtifactPolymorphic
  solutionId?: number
}) => {
  const [projectsWithoutAccess, setProjectsWithoutAccess] = useState<
    (string | null)[]
  >([])
  const { clientProjectData } = useClientProjectContext()

  // Disable picker entries using active_solution_ids from /api/v2/projects/
  // (no per-project /solutions/ fan-out).
  useEffect(() => {
    if (!solutionId) return

    let disabledProjects: (string | null)[] = []

    if (mode !== ROUTED_REPORT_MODES.EDIT_MODEL) {
      disabledProjects = clientProjectData
        .filter((clientProject) => {
          const activeIds = clientProject.active_solution_ids ?? []
          return !activeIds.includes(solutionId)
        })
        .map((item) => `${item.client.id}-${item.project.id}`)
    } else if (artifact?.project_solution?.project) {
      const currentProjectId = artifact.project_solution.project.id
      const currentClientId = artifact.client?.id

      disabledProjects = clientProjectData
        .filter(
          (clientProject) =>
            Number(clientProject.project.id) !== currentProjectId ||
            clientProject.client.id !== currentClientId,
        )
        .map((item) => `${item.client.id}-${item.project.id}`)
    }

    disabledProjects.push(null) // Also disable the 'empty' option
    setProjectsWithoutAccess(disabledProjects)
  }, [solutionId, clientProjectData, mode, artifact])

  return projectsWithoutAccess
}

export default useProjectAccess
